// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3uIrR","inputDescription":"styles_inputDescription__3iTWF"};